import { type LocaleType, useResource } from '@landsbankinn/l16n';
import { useApplicationServerContext } from '../../../../state';
import { isCorporate } from '../../../isCorporate';
import { cultureDropdownRes } from './CultureDropdown.res';
import { LanguageSwitcher } from './LanguageSwitcher';

export function CultureDropdown() {
  const { r, setLocale } = useResource();
  const [serverState] = useApplicationServerContext();

  const languages: LocaleType[] = ['is', 'en'];
  const isCorporateClient = isCorporate(serverState.clientName['is']);
  if (!isCorporateClient) languages.push('pl');

  return (
    <LanguageSwitcher
      ariaLabel={r(cultureDropdownRes.selectLanguage)}
      items={languages}
      placeholder={r(cultureDropdownRes.language)}
      onSelect={(value: LocaleType) => {
        setLocale?.(value);
      }}
    />
  );
}
